import { useRef, useState, useEffect } from 'react'

const useGetMaxHeight = (selector, extraProps = { extraMargin: 8 }) => {
  const [height, setHeight] = useState('auto')
  // save in ref in order to avoid race conditions
  const maxRegisteredHeight = useRef(0)

  useEffect(() => {
    const element = document.querySelector(selector)

    if (!element) {
      return
    }

    const observer = new ResizeObserver(([entry]) => {
      if (entry.contentRect.height > maxRegisteredHeight.current) {
        const calculatedHeight = entry.contentRect.height + extraProps.extraMargin
        maxRegisteredHeight.current = calculatedHeight
        setHeight(calculatedHeight)
      }
    })
    observer.observe(element)
  }, [selector, extraProps])

  return height
}

export default useGetMaxHeight
